module.exports = __webpack_public_path__ + "img/Scale-min.31ab7458.png";